// removed by extract-text-webpack-plugin
module.exports = {"verticallyCentered":"SimpleModal-style__verticallyCentered__6d6beba7","horizontallyRight":"SimpleModal-style__horizontallyRight__6d6beba7","horizontallyCentered":"SimpleModal-style__horizontallyCentered__6d6beba7","verticallyHorizontallyCentered":"SimpleModal-style__verticallyHorizontallyCentered__6d6beba7"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/SimpleModal/SimpleModal-style.scss
// module id = 4209
// module chunks = 62